export default httpClient => ({
    save: async (dados, token) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json", "Content-Type": "multipart/form-data" }
        const response = await httpClient.post('/parceiros', dados, { headers });
        console.log(dados)
        return {
            data: response.data
        }
    },
    update: async (dados, token) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json", "Content-Type": "multipart/form-data" }
        const response = await httpClient.post('/parceiros/' + dados.get('id'), dados, { headers });
        return {
            data: response.data
        }
    },
    getById: async ({ id, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.get('/parceiros/' + id, { headers });
        return {
            data: response.data
        }
    },
    getAll: async ({ token }) => {
        const headers = {
            "Authorization": "Bearer " + token
        }
        const response = await httpClient.get('/parceiros', { headers });
        return { data: response.data }
    },
    delete: async ({ id, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.delete('/parceiros/' + id, { headers });
        return {
            data: response
        }
    },
    getAllSite: async () => {
        const response = await httpClient.get('/parceiros-site');
        return { data: response.data }
    },
});